import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Edition } from '../models/edition.model';

@Injectable({
  providedIn: 'root'
})
export class EditionsService {
  private readonly dataUrl = 'assets/data/editions.json';

  constructor(private readonly http: HttpClient) {}

  getEditions(): Observable<Edition[]> {
    return this.http.get<Edition[]>(this.dataUrl);
  }
}
